export const READER_REQUEST_TYPES = {
  linkBoxRing: 1 << 0,
  activateTags: 1 << 1,
  deactivateTags: 1 << 2,
  replaceDefectiveTags: 1 << 3,
  setProductionDate: 1 << 4
};
